<template>
    <div>
        <base-header type="gradient-success" class="pb-7">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h1 class="d-inline-block mb-0">Rechnungen</h1>
<!--                    <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                        <route-bread-crumb></route-bread-crumb>
                    </nav>-->
                </div>
                <div class="col-lg-6 col-5 text-right">
                    <!--                    <base-button size="sm" type="neutral">New</base-button>
                                        <base-button size="sm" type="neutral">Filters</base-button>-->
                </div>
            </div>
            <!-- Card stats -->
            <div class="row">
                <div class="col-xl-4 col-md-6">
                    <InvoiceOpenNumber></InvoiceOpenNumber>
                </div>
                <div class="col-xl-4 col-md-6">
                    <InvoiceOpenAmount></InvoiceOpenAmount>
                </div>
                <div class="col-xl-4 col-md-6">
                    <InvoiceSubscription></InvoiceSubscription>
                </div>
            </div>
        </base-header>
        <div class="container-fluid mt--6">
            <div class="row">
                <div class="col">
                    <invoices-table title="Rechnungen"></invoices-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import InvoicesTable from '@/views/Tables/InvoicesTable';
import StatsCard from '@/components/Cards/StatsCard';
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import InvoiceOpenNumber from "@/views/Widgets/InvoiceOpenNumber";
import InvoiceOpenAmount from "@/views/Widgets/InvoiceOpenAmount";
import InvoiceSubscription from "@/views/Widgets/InvoiceSubscription";

export default {
    name: "Invoices",
    components: {
        StatsCard,
        InvoicesTable,
        RouteBreadCrumb,
        InvoiceOpenNumber,
        InvoiceOpenAmount,
        InvoiceSubscription
    },
}
</script>

<style scoped>

</style>
